/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

const initialState: CustomerData | null = null

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    resetCustomer: () => initialState,
    incrementLockIndicator: (state: CustomerData | null, action): any => {
      if (!state) return state
      let lockIdx = state.ownedlocks.findIndex((l) => l._id === action.payload)
      let lock = state.ownedlocks[lockIdx || 0]

      if (lock) {
        state.ownedlocks[lockIdx].indicatorNumber = lock.indicatorNumber ? lock.indicatorNumber + 1 : 1

        return state
      }
      lockIdx = state.lockaccesses.findIndex((l) => l._id === action.payload)
      lock = state.lockaccesses[lockIdx || 0]
      if (lock) {
        state.lockaccesses[lockIdx].indicatorNumber = lock.indicatorNumber ? lock.indicatorNumber + 1 : 1
      }

      return state
    },

    resetLockIndicator: (state: CustomerData | null, action): any => {
      if (!state) return state
      let lockIdx = state.ownedlocks.findIndex((l) => l._id === action.payload)
      let lock = state.ownedlocks[lockIdx || 0]

      if (lock) {
        state.ownedlocks[lockIdx].indicatorNumber = 0

        return state
      }

      lockIdx = state.lockaccesses.findIndex((l) => l._id === action.payload)
      lock = state.lockaccesses[lockIdx || 0]
      if (lock) {
        state.lockaccesses[lockIdx].indicatorNumber = 0
      }

      return state
    },
    setCustomer: (_, action) => {
      if (!action.payload) return initialState

      const accesses: Lock[] = []

      if (action.payload.ownedlocks) {
        action.payload.ownedlocks.forEach((lock: Lock) => {
          accesses.push(lock)
        })
      }

      if (action.payload.lockaccesses) {
        action.payload.lockaccesses.forEach((lock: Lock) => {
          accesses.push(lock)
        })
      }

      if (action.payload.passages) {
        action.payload.passages.forEach((lock: Lock) => {
          accesses.push(lock)
        })
      }

      if (action.payload.easy_accesses) {
        action.payload.easy_accesses.forEach((lock: Lock) => {
          accesses.push(lock)
        })
      }

      const uniqueAccesses = accesses.filter((v, i, a) => a.findIndex((t) => t._id === v._id) === i)

      return { ...action.payload, allAccesses: uniqueAccesses, lastFetched: Date.now() }
    },
  },
})

export const { resetCustomer, setCustomer, incrementLockIndicator, resetLockIndicator } = customerSlice.actions

export default customerSlice.reducer
